// DS1.7.14
import React from 'react';
import c from 'classnames';
import s from './BetaBadge.scss';
const BetaBadge = ({ badgeType, size, variant, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'], s[`size-${size}`], s[`variant-${variant}`])
    }, badgeType === 'beta' ? 'Beta' : 'New!');
};
BetaBadge.displayName = 'BetaBadge';
export default BetaBadge;
